module.exports = __webpack_public_path__ + "img/cw15.76a88cd6.jpg";